import { render, staticRenderFns } from "./SecondaryButton.vue?vue&type=template&id=1d5c8366&scoped=true&"
import script from "./SecondaryButton.vue?vue&type=script&lang=js&"
export * from "./SecondaryButton.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryButton.vue?vue&type=style&index=0&id=1d5c8366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5c8366",
  null
  
)

export default component.exports